var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_9088",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_9088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0048 19.5513C20.7467 19.5513 21.3799 19.2871 21.9044 18.7588C22.4291 18.2304 22.6915 17.5953 22.6915 16.8533C22.6915 16.1114 22.4272 15.4781 21.8985 14.9533C21.3702 14.4289 20.7351 14.1667 19.9931 14.1667C19.2512 14.1667 18.618 14.4308 18.0935 14.9592C17.5688 15.4875 17.3065 16.1226 17.3065 16.8646C17.3065 17.6065 17.5708 18.2399 18.0994 18.7646C18.6277 19.289 19.2628 19.5513 20.0048 19.5513ZM19.999 32.795C23.1315 30.0683 25.608 27.2953 27.4285 24.4758C29.2491 21.6564 30.1594 19.2179 30.1594 17.1604C30.1594 14.1112 29.1941 11.5946 27.2635 9.61042C25.333 7.62653 22.9115 6.63458 19.999 6.63458C17.0865 6.63458 14.6649 7.62653 12.7344 9.61042C10.8038 11.5946 9.83854 14.1112 9.83854 17.1604C9.83854 19.2179 10.7488 21.6564 12.5694 24.4758C14.3899 27.2953 16.8665 30.0683 19.999 32.795ZM19.999 35.0321C16.0823 31.5685 13.132 28.3382 11.1481 25.3413C9.16396 22.3446 8.17188 19.6176 8.17188 17.1604C8.17188 13.6346 9.31993 10.7264 11.616 8.43583C13.9119 6.14528 16.7062 5 19.999 5C23.2917 5 26.086 6.14528 28.3819 8.43583C30.678 10.7264 31.826 13.6346 31.826 17.1604C31.826 19.6176 30.834 22.3446 28.8498 25.3413C26.8659 28.3382 23.9156 31.5685 19.999 35.0321Z",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.cf3b2d2ecd2b482e5139ceff45aad262.svg";
export { ForwardRef as ReactComponent };